import React, { useContext } from 'react'
import styles from './styles.module.scss'
import { LocalStorageKeyEnum } from 'localStorage.enum'
import authentication from 'services/authentication'
import { useNavigate } from 'react-router-dom'
import { gapi } from 'gapi-script'
import { SnackbarContext } from 'components/ui/snackbar/context/Snackbar'
import GoogleLogin, { GoogleLoginResponse } from 'react-google-login'

const Landing: React.FC = () => {
  const navigate = useNavigate()
  const snackbarContext = useContext(SnackbarContext)
  async function responseGoogle(response: GoogleLoginResponse | any) {
    const auth2 = gapi.auth2.getAuthInstance()
    if (
      (auth2 !== null && response.accessToken) ||
      !localStorage.getItem(LocalStorageKeyEnum.TOKENID)
    ) {
      const autash2 = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token
      localStorage.setItem(LocalStorageKeyEnum.TOKENID, autash2)
      await authentication
        .login(autash2)
        .then((r) => {
          localStorage.setItem(LocalStorageKeyEnum.USERID, r.user.id.toString())
          localStorage.setItem(LocalStorageKeyEnum.JWTTOKEN, r.jwtToken)
          localStorage.setItem(LocalStorageKeyEnum.ADMIN, r.user.admin.toString())
          navigate('/timetracker')
        })
        .catch((e) => snackbarContext?.setShowSnackbarData(true, 'Login failed'))
    }
  }

  // async function responseGoogle(response: GoogleLoginResponse) {
  //   if (!!response.credential && !localStorage.getItem(LocalStorageKeyEnum.TOKENID)) {
  //     localStorage.setItem(LocalStorageKeyEnum.TOKENID, response.credential)
  //     await authentication.login(response.credential).then((r) => {
  //       localStorage.setItem(LocalStorageKeyEnum.USERID, r.user.id.toString())
  //       localStorage.setItem(LocalStorageKeyEnum.JWTTOKEN, r.jwtToken)
  //       localStorage.setItem(LocalStorageKeyEnum.ADMIN, r.user.admin.toString())
  //       navigate('/timetracker')
  //     })
  //   }
  // }

  return (
    <div className={styles.landing}>
      <div className={styles.container}>
        <div className={styles.containerInner}>
          <div className={styles.logo}>
            <span>
              brain<span>hr</span>
            </span>
          </div>
          {/* <GoogleLoginButton
            onSuccess={responseGoogle}
            onError={() => snackbarContext?.setShowSnackbarData(true, 'Login failed')}
          /> */}
          <GoogleLogin
            clientId={process.env.REACT_APP_CLIENT_ID ?? ''}
            onSuccess={responseGoogle}
          />
        </div>
      </div>
    </div>
  )
}

export default Landing
